
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppHeader',
  data () {
    return {
      show: false as boolean
    }
  },
  methods: {
    // メニューの表示・非表示切替
    toggle: function (event: Event) {
      this.show = !this.show
    },

    // メニューの非表示
    hide: function (event: Event) {
      this.show = false
    }
  },
  computed: {
    navHideClass () {
      return {
        'disable-menu-area': (this as any).show,
        hidden: !(this as any).show
      }
    }
  }
})
